import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const OutletHeroesService = {
  async getOutletHeroes() {
    let response = await $axios.get($api("outlet_heroes")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : null,
      status: response?.status,
    };
  },

  async createOutletHeroes(payload: any) {
    try {
      const { data, status } = await $axios.post(
        $api("outlet_heroes"),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async updateOutletHeroes(id: number, payload: any) {
    try {
      const { data, status } = await $axios.post(
        $api("outlet_heroes_id", { id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteOutletHeroes(id: number) {
    try {
      const { data, status } = await $axios.delete(
        $api("outlet_heroes_id", { id }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
};
